import {ajaxPost} from '../ajax';

export function clone(object)
{
    return JSON.parse(JSON.stringify(object));
}

export function fnSearchEmployee (search, onSuccess, countOnly, start, max) 
{
    var data = 
    {
        Search:search,
    }

    if( global.userType == "ADMIN" )
    {
        data.Department = [];
    }
    else
    {
        //data.Company = global.company;
        data.Department = ['Inflight Services'];
        if( global.department == 'Flight Operations')
            data.Department.push( 'Flight Operations');
    }

    ajaxPost({
        url:countOnly ? '/EmployeeAPI/CountEmployees' : '/EmployeeAPI/SearchEmployees',
        data:data,
        startIndex:start != null ? start : 0,
        maxData: max != null ? max : 50,
        onSuccess: resp =>
        {
            onSuccess( resp )
        },
        finally:()=>{}
    }
)
}




// WEBPACK FOOTER //
// ./src/admin/utils.js